var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nhome_main",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"nhome_main_center",staticStyle:{"flex":"1","width":"90%","padding-top":"10px","height":"100%","margin":"0 auto"}},[_c('div',{attrs:{"id":"nhome_main_center_right"}},_vm._l((_vm.menu),function(item){return _c('homeBox',{key:item.index,class:item.cls,attrs:{"box":{
          start: item.color.start,
          end: item.color.end,
          pic: item.color.pic,
          title: item.title,
          path: item.path,
        }}})}),1)]),_c('div',{staticStyle:{"clear":"both"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }